function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { default as DividerWrapper } from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import _merge from 'lodash/merge';
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { color } from "../../utils/index.js";
var VARIANTS = {
  SECTION: 'section',
  SOLID: 'solid',
  DASHED: 'dashed'
};
function getAppearanceDef(variant) {
  var appearancesDef = _defineProperty(_defineProperty(_defineProperty({}, VARIANTS.SECTION, {
    height: '4px',
    backgroundColor: color(COLOR_VARIANTS.ALICE),
    borderWidth: 0
  }), VARIANTS.SOLID, {
    borderColor: color(COLOR_VARIANTS.GAINSBORO),
    '&::before, &::after': {
      borderColor: color(COLOR_VARIANTS.GAINSBORO)
    }
  }), VARIANTS.DASHED, {
    borderStyle: 'dashed',
    borderColor: color(COLOR_VARIANTS.GAINSBORO),
    '&::before, &::after': {
      borderColor: color(COLOR_VARIANTS.GAINSBORO)
    }
  });
  return appearancesDef[variant] || appearancesDef[VARIANTS.SECTION];
}
export var Divider = function Divider(_ref) {
  var variant = _ref.variant,
    children = _ref.children,
    testId = _ref.testId,
    isRounded = _ref.isRounded;
  return /*#__PURE__*/React.createElement(DividerWrapper, {
    className: "__ds__comp",
    "data-testid": testId,
    sx: _merge({
      borderRadius: isRounded ? '25px' : ''
    }, getAppearanceDef(variant))
  }, children && /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.BODY2,
    component: "span",
    color: color(COLOR_VARIANTS.GREYCHATEAU)
  }, children));
};